module.exports = __webpack_public_path__ + "img/logo-nbz.972b113e.png";